import Store from 'redux/store';
import { trackingPGS } from '../clients';

import {
  FETCH_TRACKING,
  FETCH_TRACKING_SUCCESS,
  FETCH_TRACKING_FAIL,
} from 'redux/Reducers/Tracking/TrackingReducer';

export const FetchTrackingPGS = async (
  User,
  finallyCallback = () => {},
  { vendorOrderId, productCode }
) => {
  Store.dispatch({ type: FETCH_TRACKING });
  trackingPGS(User)
    .get(
      `/Order/Tracking/${vendorOrderId}/${productCode}?isSupplierOrderId=true`
    )
    .then(
      ({ data: { trackingCode, urlTracking, deliveryForecast, statuses } }) => {
        Store.dispatch({
          type: FETCH_TRACKING_SUCCESS,
          payload: {
            trackingCode,
            urlTracking,
            deliveryForecast,
            statuses,
          },
        });
      }
    )
    .catch((e) => {
      Store.dispatch({
        type: FETCH_TRACKING_FAIL,
        payload: {
          error: e,
        },
      });
    })
    .finally(() => {
      finallyCallback();
    });
};
